//initial redux
import { put, call, takeEvery, takeLatest, fork, all, take, select } from "redux-saga/effects";
import masterImportService from "../../services/masterImport";
import importStatusService from "../../services/importStatus";
import { delay } from "redux-saga";

const HISTORY_REFRESH_INTERVAL = 10000;

const initialState = {
	output: [],
	isBusy: false,
	errors: [],

	refreshingHistory: true,
	history: null,
	onPage: false,

	uploadedStatusLinks: [],
};

/////////
//types
export const types = {
	NOTIFY_ON_PAGE: "screens/import/overview/NOTIFY_ON_PAGE",
	NOTIFY_LEFT_PAGE: "screens/import/overview/NOTIFY_LEFT_PAGE",
	START_HISTORY_QUERY_POLLING: "screens/import/overview/START_HISTORY_QUERY_POLLING",
	QUERY_HISTORY: "screens/import/overview/QUERY_HISTORY",
	ON_HISTORY_RETURNED: "screens/import/overview/ON_HISTORY_RETURNED",
	UPLOAD_MASTER: "screens/import/overview/UPLOAD_MASTER",
	ON_UPLOAD: "screens/import/overview/ON_UPLOAD_MASTER",
	PRINT: "screens/import/overview/PRINT_MASTER",
	CLEAR: "screens/import/overview/CLEAR_MASTER",
	ON_UPLOAD_FAILED: "screens/import/overview/ON_UPLOAD_FAILED_MASTER",
	ON_UPLOAD_COMPLETE: "screens/import/overview/ON_UPLOAD_COMPLETE_MASTER"
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.NOTIFY_ON_PAGE:
				return { ...state, onPage: true };
			case types.NOTIFY_LEFT_PAGE:
				return { ...state, onPage: false };
			case types.UPLOAD_MASTER:
				return { ...state, isBusy: true, importAttempted: true };
			case types.ON_UPLOAD:
				return { ...state, isBusy: false };
			case types.ON_UPLOAD_COMPLETE:
				return { ...state, isBusy: false, uploadedStatusLinks: action.payload };
			case types.ON_UPLOAD_FAILED:
				return { ...state, isBusy: false, errors: state.errors.concat(action.payload).slice(-10), uploadedStatusLinks: [] };
			case types.PRINT:
				return { ...state, output: state.output.concat(action.payload.msg) };
			case types.CLEAR:
				return { ...state, output: [] };
			case types.QUERY_HISTORY:
				return { ...state  };
			case types.ON_HISTORY_RETURNED:
				return { ...state, history: action.payload.history, refreshingHistory: false };
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.startQueryHistoryPolling(),
			this.onUpload(),
			this.getHistory()
		]);
	},

	*startQueryHistoryPolling() {

		yield takeLatest(types.START_HISTORY_QUERY_POLLING, function*({ payload }) {

			for (; ;) {
				yield delay(HISTORY_REFRESH_INTERVAL);
				const onPage = yield select(x => x.importOverview.onPage);
				if (onPage) {
					yield put(actions.queryHistory(payload.from, payload.to));
				} else {
					return;
				}
			}
		});
	},

	*getHistory() {

		yield takeEvery(types.QUERY_HISTORY, function*({ payload }) {

			let history = yield call(
				importStatusService.getImportHistory,
				payload.from,
				payload.to);

			if(!history.length)
				history = [];

			yield put(actions.onHistoryReturned(history));

		});
	},

	*onUpload() {

		yield takeEvery(types.UPLOAD_MASTER, function*({ payload }) {

			let hasFailed = false;

			// Ensure only .xlsx files have been uploaded.

			for(let i = 0; i > payload.files.length; i++) {
				const file = payload.files[i];
				const valid = /\.xlsx$/.test(file.name);
				if(!valid) {
					yield put(actions.print(`%C-- INVALID FILES UPLOADED - ONLY .XLSX FILES ARE SUPPORTED --`));
					yield put(actions.genericAction(types.ON_UPLOAD_FAILED, { payload: "INVALID FILE TYPES"}));
					return;
				}
			}

			yield put(actions.print(`%C-- BEGIN UPLOAD OF ${payload.files.length} FILE/S --`));

			let statusLinks = [];

			const files = [...payload.files];

			for(let ii = 0, ilen = files.length; ii < ilen; ii++) {

				yield put(actions.print(`%C-- UPLOADING FILE ${ii+1}/${payload.files.length} --`));

				const file = files[ii];
				const fileName = files[ii].name;
				let id = yield call(masterImportService.uploadSpreadsheetForImport, file, fileName);

				statusLinks.push({ id, fileName });

				yield put(actions.print(`%C-- FILE ${ii+1}/${payload.files.length} UPLOAD COMPLETE --`));

			}

			yield put(actions.print(`%C-- ALL FILES HAVE FINISHED UPLOADING. \n REFER TO STATUS HISTORY AT LEFT FOR MORE DETAILS --`));
			yield put(actions.updateStatusLinks(statusLinks));

		});
	}
};

////////
//actions
export const actions = {

	notifyOnPage() {
		return {
			type: types.NOTIFY_ON_PAGE
		}
	},

	notifyLeftPage() {
		return {
			type: types.NOTIFY_LEFT_PAGE
		}
	},


	startQueryHistoryPolling(from, to) {
		return {
			type: types.START_HISTORY_QUERY_POLLING,
			payload: {
				from, to
			}
		};
	},

	queryHistory(from, to) {

		return {
			type: types.QUERY_HISTORY,
			payload: {
				from, to
			}
		};
	},

	onHistoryReturned(history) {
		return {
			type: types.ON_HISTORY_RETURNED,
			payload: {
				history
			}
		}
	},

	upload(files) {
		return {
			type: types.UPLOAD_MASTER,
			payload: {
				files
			}
		};
	},

	onUpload() {
		return {
			type: types.ON_UPLOAD,
			payload: {}
		};
	},

	updateStatusLinks(statusLinks) {
		return {
			type: types.ON_UPLOAD_COMPLETE,
			payload: statusLinks
		};
	},

	print(msg) {
		return {
			type: types.PRINT,
			payload: { msg }
		};
	},

	clear() {
		return {
			type: types.CLEAR,
			payload: {}
		};
	},

	genericAction(type, data) {
		return {
			type,
			payload: data
		};
	}
};



// WEBPACK FOOTER //
// ./src/ui/ImportOverview/redux.js